import React from "react";
import './inputField.css'

export const InputBox = ({ placeholder, value, type, onChange, customClass, autoFocus}) => {
    return (
      <div className="inputStyle">
        <input
          className={customClass}
          placeholder={placeholder}
          value={value}
          type={type}
          onChange={onChange}
          autoFocus={autoFocus}
        />
      </div>
    );
  };